import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return <div className="loading">Loading</div>;
};

export default LoadingSpinner;
